import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { notification, Switch } from "antd";
import { Field, Form, Formik } from "formik";
import { includes, isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import Modal from "react-modal";

import { CloseModal } from "../../../components/icons";
import amplitude from "../../../externals/amplitude";
const UpdateStorageAccess = ({
  openStorageAccessModal,
  setOpenStorageAccessModal,
  storage,
  updateStorageMultipleFolderPath,
  getStorageDetails,
  clientSetting,
  id,
}) => {
  const [storageId, setStorageId] = useState("");
  const [formValues, setFormValues] = useState([{ multiple_folder_path: "" }]);
  const [storageName, setStorageName] = useState("");
  const [defaultStorage, setDefaultStorage] = useState(false);
  const [isActive, setIsActive] = useState(true);

  const initialState = {
    folder_path: "",
    multiple_folder_path: { multiple_folder_path: "" },
    storage_name: "",
  };

  function hasEmptyKey(array, key) {
    return array.filter((obj) => obj.hasOwnProperty(key) && obj[key] !== "");
  }

  useEffect(() => {
    if (storage) {
      setIsActive(storage.isActive);
      setStorageId(storage?._id);
      setStorageName(storage?.storage_name);
      setDefaultStorage(storage?.defaultStorage);
    }

    if (storage?.multiple_folder_path?.length && !isEmpty(storage?.multiple_folder_path)) {
      setFormValues(storage.multiple_folder_path);
    } else {
      setFormValues([{ multiple_folder_path: "" }]);
    }
  }, [storage]);

  const handleSubmit = async ({ folder_path, multiple_folder_path }) => {
    const filtered_array = hasEmptyKey(formValues, "multiple_folder_path");
    let data = {
      _id: storageId,
      multiple_folder_path: filtered_array,
      isActive,
      storageName,
      defaultStorage,
      entityId: id,
    };
    const { value } = await updateStorageMultipleFolderPath(data);
    if (value.success) {
      notification["success"]({ message: value?.message });
    }
    await getStorageDetails();
    setOpenStorageAccessModal(false);
    amplitude.logEvent("storage_updated", { storageId });
  };

  const handleClick = () => {
    setFormValues([...formValues, { multiple_folder_path: "" }]);
  };

  const handleChange = (i, e, setFieldValue) => {
    let newFormValues = [...formValues];
    newFormValues[i][e.target.name] = e.target.value;
    setFormValues(newFormValues);
    setFieldValue("multiple_folder_path", formValues);
    setFieldValue("folder_path", e.target.value);
  };

  const removePath = (positionToRemove, setFieldValue) => {
    let newFormValues = [...formValues];
    if (positionToRemove < 0 || positionToRemove >= newFormValues.length) {
      return;
    }

    newFormValues.splice(positionToRemove, 1);
    if (newFormValues.length === 0) {
      setFormValues([{ multiple_folder_path: "" }]);
      setFieldValue("multiple_folder_path", [{ multiple_folder_path: "" }]);
    } else {
      setFormValues(newFormValues);
      setFieldValue("multiple_folder_path", newFormValues);
    }
  };

  const closeUpdateStorageAccess = () => {
    setOpenStorageAccessModal(false);
  };

  return (
    <>
      <Modal
        isOpen={openStorageAccessModal}
        onRequestClose={closeUpdateStorageAccess}
        shouldCloseOnOverlayClick={false}
        contentLabel="Alert Modal"
        portalClassName="react-modal"
        overlayClassName="modal"
        className="modal-dialog react-modal-dialog-xs modal-dialog-centered"
      >
        <Formik initialValues={initialState} onSubmit={handleSubmit}>
          {({ dirty, values, errors, touched, setFieldValue, resetForm }) => (
            <div className="modal-content">
              <Form>
                <div className="react-modal-header">
                  <h5 className="react-modal-title">Update Storage Access</h5>
                  <button type="button" onClick={closeUpdateStorageAccess} className="btn btn__default">
                    <CloseModal />
                  </button>
                </div>
                <div className="react-modal-body">
                  {clientSetting?.permissions?.multipleStoragePath ? (
                    <>
                      {formValues.map((element, index) => {
                        return (
                          <>
                            <div class="form-group">
                              <label className="form-label">Bucket Folder Path {` ${index + 1} `} </label>
                              <div className="d-flex gap-3">
                                <div className="flex-grow-1">
                                  <Field
                                    name="multiple_folder_path"
                                    type="text"
                                    value={element.multiple_folder_path}
                                    className="form-control"
                                    onChange={(e) => handleChange(index, e, setFieldValue)}
                                  />
                                </div>
                                <button
                                  className="btn btn-primary"
                                  type="button"
                                  onClick={() => {
                                    removePath(index, setFieldValue);
                                  }}
                                >
                                  X
                                </button>
                              </div>
                              {touched.multiple_folder_path && errors.multiple_folder_path && (
                                <div className="invalid-feedback">{errors.multiple_folder_path}</div>
                              )}
                            </div>
                            {index === formValues.length - 1 && (
                              <button
                                type="button"
                                disabled={includes([null, "", undefined, "null"], element.multiple_folder_path)}
                                className="btn btn-primary btn-small"
                                onClick={() => handleClick()}
                              >
                                Add More Bucket Folder Path
                              </button>
                            )}
                          </>
                        );
                      })}{" "}
                    </>
                  ) : (
                    <>
                      <div class="form-group">
                        <label className="form-label">Bucket Folder Path</label>
                        <Field
                          name="folder_path"
                          type="text"
                          className="form-control"
                          onChange={(e) => {
                            setFieldValue("folder_path", e.target.value);
                          }}
                          disabled={true}
                        />
                        {touched.folder_path && errors.folder_path && (
                          <div className="invalid-feedback">{errors.folder_path}</div>
                        )}
                      </div>{" "}
                    </>
                  )}
                  <div class="form-group mt-3">
                    <label className="form-label me-2">Active</label>
                    <Switch
                      className="small-switcher"
                      checked={isActive}
                      checkedChildren={<CheckOutlined />}
                      unCheckedChildren={<CloseOutlined />}
                      onChange={(e) => {
                        setIsActive(e);
                      }}
                    />
                  </div>
                  {storage?.storage_type === "production" && (
                    <div class="form-group mt-3">
                      <label className="form-label me-2">Default Storage</label>
                      <Switch
                        className="small-switcher"
                        checked={defaultStorage}
                        checkedChildren={<CheckOutlined />}
                        unCheckedChildren={<CloseOutlined />}
                        onChange={(e) => {
                          setDefaultStorage(e);
                        }}
                      />
                    </div>
                  )}
                </div>
                <div className="react-modal-footer">
                  <div className="react-foo-container">
                    <div className="right-btn-block text-md-end text-center">
                      <button type="button" className="btn btn-white" onClick={closeUpdateStorageAccess}>
                        Cancel
                      </button>
                      <button type="submit" className="btn btn-primary">
                        Update
                      </button>
                    </div>
                  </div>
                </div>
              </Form>
            </div>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default UpdateStorageAccess;
